import { EventForm } from '../../../components/Events/AddEvent'

export const AddEvent = () => {
    return <EventForm />
}
